import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'Valeria T.',
  role: 'Docente de Tecnología de Alimentos · Lima, Perú',
  text: 'El material sobre embutidos artesanales le cambió la cara a mis alumnos. Por fin entienden por qué el nitrito es indispensable en los curados y por qué la temperatura interna no es opcional. Es el recurso más claro que encontré para este tema.'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  role: 'Profesor de taller de alimentos · Montevideo, Uruguay',
  text: 'El banco de evaluaciones vale por sí solo el precio del pack. Nunca más construí un examen práctico desde cero bajo presión. Salgo de cada trimestre con la satisfacción de tener todo resuelto.'
}, {
  initials: 'DG',
  name: 'Daniel G.',
  role: 'Docente de educación técnica · Caracas, Venezuela',
  text: 'Los proyectos productivos extra transformaron el grupo más difícil que tenía. Mis alumnos llegaron a la feria escolar con productos reales, bien calculados y con empaque. Eso no lo encontré en ningún otro material.'
}, {
  initials: 'AM',
  name: 'Ana M.',
  role: 'Docente de procesamiento de alimentos · Buenos Aires, Argentina',
  text: 'El recetario técnico me devolvió el tiempo de taller. Antes perdía los primeros veinte minutos dictando parámetros y formulaciones. Ahora mis alumnos llegan con el recetario leído y podemos ir directo a elaborar.'
}, {
  initials: 'SR',
  name: 'Sebastián R.',
  role: 'Profesor de tecnología alimentaria · Quito, Ecuador',
  text: 'El banco de actividades fue una revelación. Tengo 50 prácticas listas para usar y cada una tiene sentido técnico real. Eso cambió completamente mi planificación y mi seguridad en el aula.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-cream-light" data-id="element-125">
      <div className="max-w-6xl mx-auto" data-id="element-126">
        <div className="text-center mb-16" data-id="element-127">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-green" data-id="element-128">
            Docentes que ya tienen su Mega Pack
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-129">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-white border border-cream-dark p-8 rounded-2xl relative shadow-sm ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-130">
              <Quote className="absolute top-6 right-6 text-cream-dark" size={48} data-id="element-131" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-132">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-133" />)}
              </div>

              <p className="text-ink italic mb-8 relative z-10 leading-relaxed text-sm" data-id="element-134">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-135">
                <div className="w-12 h-12 rounded-full bg-green flex items-center justify-center text-white font-bold text-lg" data-id="element-136">
                  {t.initials}
                </div>
                <div data-id="element-137">
                  <div className="font-bold text-green" data-id="element-138">{t.name}</div>
                  <div className="text-xs text-terracota font-medium" data-id="element-139">
                    {t.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}